import { render, staticRenderFns } from "./TutorProfileDetails.vue?vue&type=template&id=27980650&"
import script from "./TutorProfileDetails.vue?vue&type=script&lang=js&"
export * from "./TutorProfileDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports